import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { createRoot } from "react-dom/client";
import { createSiteShell } from "@coremind/foundation-shell-core";
// Eagerly import so webpack shares the singleton with any federated remotes.
import "@coremind/identity-core";
import { authSiteAdapter } from "./adapter";
import { resolveTargetApiBaseUrl } from "./authRouting";
const env = window.__COREMIND_ENV__ ?? {};
const App = createSiteShell(authSiteAdapter, {
    auth: {
        userPoolId: env.VITE_COGNITO_USER_POOL_ID,
        userPoolClientId: env.VITE_COGNITO_USER_POOL_CLIENT_ID,
        identityPoolId: env.VITE_COGNITO_IDENTITY_POOL_ID,
        oauth: env.VITE_COGNITO_OAUTH_DOMAIN
            ? {
                domain: env.VITE_COGNITO_OAUTH_DOMAIN,
                redirectSignIn: [env.VITE_COGNITO_OAUTH_REDIRECT_SIGNIN].filter(Boolean),
                redirectSignOut: [env.VITE_COGNITO_OAUTH_REDIRECT_SIGNOUT].filter(Boolean),
                scopes: (env.VITE_COGNITO_OAUTH_SCOPES ?? "email openid profile").split(" "),
                responseType: env.VITE_COGNITO_OAUTH_RESPONSE_TYPE ?? "code",
            }
            : undefined,
    },
    // The shell's own session check (getAuthMe/getSession) must hit the *target* site's API, not
    // this site's own default -- e.g. redirect_uri=mgmt.offsetmind.com needs mgmt.api.offsetmind.com,
    // not this env's api.dev.offsetmind.com default. Without this the sign-in redirect itself still
    // works (a plain window.location.replace), but the shell's background calls while still on this
    // page 404/CORS-fail against the wrong host.
    apiBaseUrl: resolveTargetApiBaseUrl(env.VITE_API_BASE_URL),
});
createRoot(document.getElementById("root")).render(_jsx(App, {}));
